import { render, staticRenderFns } from "./PortalRegisterForm.vue?vue&type=template&id=b037d4b2"
import script from "./PortalRegisterForm.vue?vue&type=script&lang=js"
export * from "./PortalRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports